import api from "../../../api";
import {typedQuery} from "../../typing";

export const reviewerRoles = typedQuery(["tprm", "reviewerRoles"], async () => {
  return await api.tprm.reviewerRoles.list();
});
